<section [ngClass]="styles.messageWrapper">
	<span [ngClass]="styles.frown">:-(</span>
	{{ 'Reports_ServiceUnavailable' | translate }}
</section>
